import { render, staticRenderFns } from "./WechatCardPage.vue?vue&type=template&id=efc7ad2e&scoped=true"
import script from "./WechatCardPage.vue?vue&type=script&lang=js"
export * from "./WechatCardPage.vue?vue&type=script&lang=js"
import style0 from "./WechatCardPage.vue?vue&type=style&index=0&id=efc7ad2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc7ad2e",
  null
  
)

export default component.exports